import { ApiService } from "./../../index";
export const getQuestionGroupList = (type: "tree" | "list") => {
  return ApiService.baseAction(`question-group/list/${type}`, {}, "GET");
};
